import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { LiveProps } from '../../../LiveContainer';
import { BiSend } from 'react-icons/bi';
import './LiveFooterMobile.scss';
import { LiveMessageItem } from '../../LiveMessages/LiveMessageItem';
import { useSendMessageMutation } from '../../../../../services/api/apiProvider';
import { Debug } from '../../../../../common/utils/debugLogs';
import { RequestSendMessage } from '../../../../../services/api/models/request/requestSendMessage';
import { PuffLoader } from 'react-spinners';
import { Card, Collapse } from 'react-bootstrap';
import { ImageCustom } from '../../../../../common/components/ImageCustom';
import giftBoxImage from '../../../../../assets/png/audienceGIfButtonImage.png';
import giftDisableImg from '../../../../../assets/svg/btn_str_gift_ban.svg';
import { LiveGiftMenu } from '../../LiveGiftMenu/LiveGiftMenu';

const LiveFooterMobile = (props: LiveProps): ReactElement => {
  const [open, setOpen] = useState(false);
  const [retryLoginCount, setRetryLoginCount] = useState(0);
  const [sendMessage] = useSendMessageMutation();
  const [showScrollBottom, setShowScrollBottom] = useState(false);
  const [isAutoScroll, setIsAutoScroll] = useState(true);
  const messageBoxRef = useRef<HTMLDivElement>(null);

  function scrollListMessageToBottom() {
    // scroll
    messageBoxRef.current?.scrollTo({
      behavior: 'smooth',
      top: messageBoxRef.current.scrollHeight,
    });
  }

  const isPureEnter = (event: any): boolean => {
    const isComposing = event.isComposing || event.keyCode === 229;
    return event.key === 'Enter' && !isComposing;
  };

  const onTextBoxKeyDown = (event: any) => {
    if (isPureEnter(event)) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const handleSendMessage = () => {
    const messageElement = document.querySelector(
      '.live-message-mobile__input_text',
    );

    const message = messageElement?.textContent;
    if (
      messageElement === null ||
      message === null ||
      message === undefined ||
      message?.length === 0
    ) {
      return;
    }

    // send message to channel
    const requestSendMessage: RequestSendMessage = {
      message: message,
      type: 'Live',
      target: props.liveState.liveData?.id,
      id: null,
    };

    sendMessage(requestSendMessage)
      .unwrap()
      .catch((error) => {
        Debug.log(`Error when sent message to channel reason: ${error}`);
      });

    messageElement.textContent = '';
    setIsAutoScroll(true);
  };

  useEffect(() => {
    const messageBox = messageBoxRef.current;
    let prevScroll = messageBox?.scrollTop || 0;

    messageBox?.addEventListener('scroll', () => {
      const { scrollHeight, clientHeight, scrollTop } = messageBox;

      if (prevScroll > scrollTop) {
        // handle when scrolling back
        setIsAutoScroll(false);
      } else if (scrollTop === scrollHeight - clientHeight) {
        // handle when scrolling to the end of the comments
        setIsAutoScroll(true);
        setShowScrollBottom(false);
      }

      prevScroll = messageBox.scrollTop;
    });
  }, [messageBoxRef.current]);

  // not join or start live yet!
  const isReady =
    props.liveState.isInLive &&
    props.liveState.liveData !== undefined &&
    props.liveState.userData !== undefined;
  return (
    <div className="live-footer-mobile-root">
      <Card className="live-message-mobile">
        {showScrollBottom ? (
          <span
            className="live-messages__scroll-to-bottom"
            onClick={scrollListMessageToBottom}
          >
            新しいコメントを見る ↓
          </span>
        ) : (
          <></>
        )}
        {!isReady && !props.liveState.isEnded ? (
          <Card.Body
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <PuffLoader size={'60px'} color={'#0275d8'}></PuffLoader>
          </Card.Body>
        ) : (
          <Card.Body
            style={{ padding: '0px' }}
            className="live-messages-mobile__messages_list"
            ref={messageBoxRef}
          >
            {props.liveState.liveComments.map((comment, index) => {
              return (
                <div key={index}>
                  <LiveMessageItem
                    liveComment={comment}
                    setShowScrollBottom={setShowScrollBottom}
                    isAutoScroll={isAutoScroll}
                    scrollListMessageToBottom={scrollListMessageToBottom}
                  ></LiveMessageItem>
                </div>
              );
            })}
          </Card.Body>
        )}

        <div className="live-message-mobile__input-and-gift-root">
          <div className="live-message-mobile__input">
            <div
              className="live-message-mobile__input_text"
              placeholder="コメントしてみましょう"
              contentEditable="true"
              onKeyDown={(event) => onTextBoxKeyDown(event)}
            ></div>
            <BiSend
              className="live-message-mobile__input__send-btn"
              onClick={handleSendMessage}
            />
          </div>
          {props.liveState.role === 'audience' && (
            <>
              {props.liveState.isEnableGift ? (
                <>
                  <div
                    onClick={() => setOpen(!open)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    className="live-message-mobile__gift"
                  >
                    <ImageCustom src={giftBoxImage} />
                  </div>
                  <div className="live-gift-mobile-root">
                    <Collapse in={open} dimension="width">
                      <div id="example-collapse-text">
                        <Card body className="live-gift-mobile-modal">
                          <LiveGiftMenu {...props} />
                        </Card>
                      </div>
                    </Collapse>
                  </div>
                </>
              ) : (
                <div className="live-message-mobile__gift">
                  <ImageCustom src={giftDisableImg} />
                </div>
              )}
            </>
          )}
        </div>
      </Card>
    </div>
  );
};

export default LiveFooterMobile;
